var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.alertsArray.length > 0
    ? _c("div", [
        _c("span", { staticClass: "title primary--text" }, [
          _vm._v(
            "\n    " + _vm._s(_vm.generateMessage("alerts.alert")) + "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "title font-weight-bold primary--text mr-auto" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.generateMessage("alerts.hypervision")) +
                "\n  "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "d-flex flex-column align-center justify-space-around",
            style: `height:${_vm.height}px; overflow-y: auto;`
          },
          _vm._l(_vm.alertsArray, function(item) {
            return _c(
              "div",
              {
                key: item.name,
                staticClass: "d-flex flex-column align-center my-3"
              },
              [
                _c("div", { staticClass: "mx-auto" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.generateMessage(`alerts.fields.${item.name}`)
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "v-chip",
                      { staticClass: "mx-auto", attrs: { small: "" } },
                      [_vm._v(_vm._s(_vm._f("showDate")(item.date)))]
                    ),
                    _vm._v(" "),
                    item.plan
                      ? _c("link-to-actionplan", {
                          staticClass: "mx-auto",
                          attrs: { color: "success", actionPlanId: item.plan }
                        })
                      : _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          { attrs: { color: "error" } },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.generateMessage(
                                                  "alerts.icons.remove"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.generateMessage(
                                      "requests.details.titles.no_actionplan"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(item.desc))])
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }